module.exports = __webpack_public_path__ + "static/spring-be72c1f845d7fb255aec9c3c2a2bdb73.png";